import type { Views } from "../constants";
import { VIEWS } from "../constants";
import { CardViewSkeleton } from "./CardView/CardViewSkeleton";
import { ListViewSkeleton } from "./ListView/ListViewSkeleton";

interface CommunityMembersV2SkeletonProps {
  view: Views;
}

export const CommunityMembersV2Skeleton = ({
  view,
}: CommunityMembersV2SkeletonProps) => {
  if (view === VIEWS.CARDS) {
    return <CardViewSkeleton />;
  }

  return <ListViewSkeleton />;
};
